import React, {useEffect} from "react";
import {makeStyles} from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import SvgIcon from '@material-ui/core/SvgIcon';

const useStyles = makeStyles({
    root: {
        height: 110,
        flexGrow: 1,
        maxWidth: 400,
    },
});

// svg
function MinusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{width: 14, height: 14}} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path
                d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z"/>
        </SvgIcon>
    );
}

// svg
function PlusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{width: 14, height: 14}} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path
                d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z"/>
        </SvgIcon>
    );
}


/**
 * @Description MateDrive Folder List design
 * @Param       data - folder data list
 * @Param       setPathName - func
 * @Param       setSelectItem - func
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function FolderList({data, pathName, setPathName, setSelectItem, setSelectedItems}) {
    const classes = useStyles();

    useEffect(() => {
        setPathName(data.length ? data[0].path : "");
        setSelectItem(data.length ? data[0] : data);
    }, [data]);

    // clicked selected item
    function handleClick(item) {
        if (pathName !== item.path) {
            setSelectedItems([]);
        }
        setPathName(item.path);
        setSelectItem(item);
    }

    const renderTree = (nodes) => (
        <TreeItem key={nodes.name} nodeId={nodes.name} label={nodes.name} onClick={() => handleClick(nodes)}>
            {
                (Array.isArray(nodes.children) ? nodes.children.map(
                        (node, index) =>
                            node.is_dir && (<div key={index}>{renderTree(node)}</div>
                            ))
                    : null)
            }
        </TreeItem>
    );

    return (
        <div className="matedrive-folder-list">
            <TreeView
                className={classes.root}
                defaultCollapseIcon={<MinusSquare/>}
                defaultExpanded={["root"]}
                defaultExpandIcon={<PlusSquare/>}
            >
                {renderTree(data)}
            </TreeView>
        </div>
    );
}

